import { ApiPath, API_BASE_URL } from '@paylink/constants';
import { DataShareService, TokenManager } from '@paylink/services';
import {
	IFoxtrotEventData,
	IPaylinkDetail,
	IVerifyCustomerResponse,
} from '@paylink/types';
import { IVerifyCustomerPayload } from '@paylink/types/verifyCustomer.types';

import { ApiClient } from '@shared/services/apiClient.service';
import { REQUEST_HEADERS, QueryParamConstant } from '@shared/constants';
import { getQueryStringValue } from '@shared/utils';
import { IThemeConfigResponse } from '@shared/types';

export class ApiService {
	private static apiClient: ApiClient;

	static get defaultHeaders() {
		const token = TokenManager.getToken();
		const featureEnv = getQueryStringValue(QueryParamConstant.FEATURE_ENV);
		const browserFPR = DataShareService.browserFPR;

		return {
			[REQUEST_HEADERS.CONTENT_TYPE]: 'application/json',
			[REQUEST_HEADERS.ACCEPT]: 'application/json, text/plain, */*',
			[REQUEST_HEADERS.FINGERPRINT]: browserFPR,
			[REQUEST_HEADERS.AUTHORIZATION]: `Bearer ${token}`,
			[REQUEST_HEADERS.TOKEN]: token,

			...(featureEnv ? { [REQUEST_HEADERS.FEATURE_ENV]: featureEnv } : {}),
		};
	}
	static init() {
		this.apiClient = new ApiClient({
			baseURL: API_BASE_URL,
			defaultHeaders: ApiService.defaultHeaders,
			allowCredentials: true,
		});
	}

	static readonly getPaylinkDetail = (): Promise<IPaylinkDetail> =>
		this.apiClient.get(ApiPath.GET_PAYLINK_DETAIL);

	static readonly getThemeConfig = (): Promise<IThemeConfigResponse> =>
		this.apiClient.get(ApiPath.THEME_CONFIG);

	static readonly verifyCustomer = (
		data: IVerifyCustomerPayload,
	): Promise<IVerifyCustomerResponse> =>
		this.apiClient.post(ApiPath.VERIFY_CUSTOMER, { body: data });

	static readonly pushEvents = (payload: IFoxtrotEventData): Promise<void> =>
		this.apiClient.post(ApiPath.EVENT_INGESTION, { body: payload });
}
